<template lang="pug">
  div
    v-layout(align-baseline justify-end)
      v-text-field(v-model="search"
                   append-icon="search"
                   class="mx-4 my-0"
                   hide-details
                   label="Find an issue")
      v-btn(:disabled="loadingIssues"
            class="ma-0 mr-4"
            color="light-blue darken-3"
            style="min-width: 15em"
            @click="notification = true; loadIssues()")
        v-progress-circular(v-if="loadingIssues"
                            size="15"
                            indeterminate)
        span(v-else) Reload the issues
      v-btn(:disabled="zabbixSites.length === 0"
            color="green darken-2"
            class="ma-0"
            style="min-width: 15em"
            @click="dialog = true")
        v-progress-circular(v-if="loadingSites"
                            size="15"
                            indeterminate)
        span(v-else) New issue

    template(v-if="loadingIssues && !notification")
      v-layout(class="mt-5" justify-center)
        v-progress-circular(size="50" indeterminate)

    template(v-else)

      open-unack-table(
        :issues="openUnackIssues"
        @refresh="loadIssues")

      closed-unack-table(
        :issues="closedUnackIssues"
        @refresh="loadIssues")

      open-ack-table(
        :issues="openAckIssues")

      closed-ack-table(
        :issues="closedAckIssues")

    v-dialog(
      v-model="dialog"
      :persistent="true"
      max-width="50rem")
      v-card
        v-card-text
          v-container
            v-layout
              v-flex
                v-form(v-model="valid")
                  v-autocomplete(
                    v-model="newIssue.site"
                    :items="zabbixSites"
                    :filter="sitesFilter"
                    :rules="[v => !!v || 'Site is required']"
                    item-text="id"
                    item-value="id"
                    label="Site"
                    placeholder="Add a site...")
        v-card-actions
          v-spacer
          v-btn(
            :disabled="posting"
            flat
            @click="dialog = false") Cancel
          v-btn(
            :disabled="posting || !valid"
            flat
            @click="save")
            v-progress-circular(
              v-if="posting"
              indeterminate)
            span(v-else) Save

</template>

<script>
import ClosedAckTable from "./Issues/ClosedAckTable.vue";
import ClosedUnackTable from "./Issues/ClosedUnackTable.vue";
import { mapActions } from "vuex";
import moment from "moment";
import OpenAckTable from "./Issues/OpenAckTable.vue";
import OpenUnackTable from "./Issues/OpenUnackTable.vue";

export default {
  name: "issues",
  components: {
    ClosedAckTable,
    ClosedUnackTable,
    OpenAckTable,
    OpenUnackTable
  },
  data () {
    return {
      dialog: false,
      loadingIssues: false,
      loadingSites: false,
      newIssue: { site: "" },
      notification: false,
      posting: false,
      issues: [],
      /*
       * Object to store categories' name from id and avoid
       * excessive redundant requests (in created) to the backend
       */
      categories: {},
      search: "",
      valid: false,
      zabbixSites: []
    };
  },
  computed: {
    filteredIssues () {
      return this.issues.filter((obj) =>
        this.$options.filters.formatIId(obj.id).
          indexOf(this.search.toUpperCase()) > -1 ||
        obj.site.indexOf(this.search.toUpperCase()) > -1 ||
        obj.description && obj.description.toLowerCase().
          indexOf(this.search.toLowerCase()) > -1);
    },
    closedAckIssues () {
      return this.
        filteredIssues.
        filter((i) => i.dateClosed !== null && i.category.id !== null);
    },
    closedUnackIssues () {
      return this.
        filteredIssues.
        filter((i) => i.dateClosed !== null && i.category.id === null);
    },
    openAckIssues () {
      return this.
        filteredIssues.
        filter((i) => i.dateClosed === null && i.category.id !== null);
    },
    openUnackIssues () {
      return this.
        filteredIssues.
        filter((i) => i.dateClosed === null && i.category.id === null);
    }
  },
  created () {
    this.loadIssues();
    // Get the production sites
    this.loadingSites = true;
    this.$http.
      get("/api/sites").
      then((r) => this.zabbixSites = Array.from(r.data)).
      finally(() => this.loadingSites = false);
  },
  methods: {
    ...mapActions(["notify"]),
    loadIssues () {
      this.loadingIssues = true;
      this.$http.
        get("/api/issues").
        then((r) => {
          /*
           * Unfortunately, there is no option to default sort by
           * dateRaised: github.com/vuetifyjs/vuetify/issues/3658
           */
          this.issues = Array.from(r.data.reverse());
          if (this.notification) {
            this.notify({
              closable: false,
              color: "green--text text--accent-3",
              msg: "Done!",
              timeout: 2500
            });
            this.notification = false;
          }
        }).
        finally(() => this.loadingIssues = false);
    },
    save () {
      this.posting = true;
      this.$http.
        post("/api/issues", {
          dateRaised: moment().format("YYYY-MM-DDTHH:mm:ss"),
          site: this.newIssue.site
        }).
        then((r) => {
          this.$http.get("/api/issues");
          this.$router.push({
            name: "issue",
            params: { id: r.data.id }
          });
        }).
        finally(() => this.posting = false);
    },
    sitesFilter (item, query) {
      // Case insensitive filter on name
      let q = query ? query : "";
      let h = item.id ? item.id : "";
      return h.toLowerCase().indexOf(q.toLowerCase()) > -1;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Issues.vue